import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {API} from '@emm/core/util/api-constants';
import {standardRetry} from '@emm/core/util/rx.util';


@Injectable({
  providedIn: 'root',
})
export class AppInfoService {
  constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

  getAppInfo(): Observable<any> {
    const url = `${this.apiUrl}${API.AppInfo}`;
    return this.http.get(url).pipe(standardRetry());
  }
}
